import { VIBE_LOG_CANARY_APP_ID } from "./log-pipeline";

/**
 * The `nexus.app.id` the tenant agent's OWN log lines carry, and therefore the
 * value of the `nexus_app_id` Loki index label they land under.
 *
 * The agent runs as a systemd unit on the server nodes, which are not Nomad
 * clients, so no stdout shipper can read it; it exports its own lines to the
 * tenant collector instead (`apps/vibe-agent/src/selflog`). Those lines carry
 * platform internals — Vault, Aurora, the server roll — and are for operators,
 * never for a customer reading their app's logs.
 *
 * Deliberately not a UUID, for the canary's reason: every real app id is a
 * Postgres `uuid` (`VibeApp.id`), so no app can ever collide with it.
 */
export const VIBE_AGENT_LOG_APP_ID = "nexus-vibe-agent";

/**
 * The `nexus.app.id` a server node's Nomad and Consul journald lines carry —
 * the raft record of a server roll (`removing server`, `member left`, leadership
 * transfer), shipped by a host collector beside the agent because a retired
 * server's root volume is deleted with it.
 *
 * Platform internals for operators, like the agent's own stream, and refused as
 * an `appId` for the same reason. Each line also carries `service.name` `nomad`
 * or `consul`, so the two daemons are separate streams under this one id.
 */
export const VIBE_SERVER_JOURNAL_LOG_APP_ID = "nexus-vibe-server-journal";

/**
 * Every `nexus.app.id` the platform writes for itself. The log gateway's request
 * contract refuses each of them as an `appId`, so no read composed from caller
 * input can select a platform stream — the canary is read only through
 * `VIBE_LOG_CANARY_QUERY`, a constant that never passes through that contract.
 */
export const VIBE_RESERVED_LOG_APP_IDS: readonly string[] = [
  VIBE_LOG_CANARY_APP_ID,
  VIBE_AGENT_LOG_APP_ID,
  VIBE_SERVER_JOURNAL_LOG_APP_ID
];
